import { Dispatch } from 'redux';
import { Moment } from 'moment';

import { fetcher } from '../../lib/request';

import { SessionParams } from '../../models/Hotels/SessionParams';
import { RoomsParams } from '../../models/Hotels/RoomsParams';

const HOTELS_HOST = process.env.REACT_APP_HOTELS_HOST;
const HOTELS_KEY = process.env.REACT_APP_HOTELS_KEY;

export const SESSION_REQUEST = 'HOTELS_SESSION_REQUEST';
export const SESSION_RESPONSE = 'HOTELS_SESSION_RESPONSE';
export const SESSION_ERROR = 'HOTELS_SESSION_ERROR';

export const PAGES_STATUS_REQUEST = 'HOTELS_PAGES_STATUS_REQUEST';
export const PAGES_STATUS_RESPONSE = 'HOTELS_PAGES_STATUS_RESPONSE';
export const PAGES_STATUS_ERROR = 'HOTELS_PAGES_STATUS_ERROR';

export const SEARCH_STATUS_REQUEST = 'HOTELS_SEARCH_STATUS_REQUEST';
export const SEARCH_STATUS_RESPONSE = 'HOTELS_SEARCH_STATUS_RESPONSE';
export const SEARCH_STATUS_ERROR = 'HOTELS_SEARCH_STATUS_ERROR';

export const PAGE_REQUEST = 'HOTELS_PAGE_REQUEST';
export const PAGE_RESPONSE = 'HOTELS_PAGE_RESPONSE';
export const PAGE_ERROR = 'HOTELS_PAGE_ERROR';

export const ROOMS_REQUEST = 'HOTELS_ROOMS_REQUEST';
export const ROOMS_RESPONSE = 'HOTELS_ROOMS_RESPONSE';
export const ROOMS_ERROR = 'HOTELS_ROOMS_ERROR';

export const RESET_HOTELS = 'HOTELS_RESET_HOTELS';

export const SET_CHECKIN = 'HOTELS_SET_CHECKIN';
export const SET_CHECKOUT = 'HOTELS_SET_CHECKOUT';
export const SET_ADULTS = 'HOTELS_SET_ADULTS';
export const SET_CHILDREN = 'HOTELS_SET_CHILDREN';
export const SET_HOTEL_ID = 'HOTELS_SET_HOTEL_ID';
export const SET_REGION_ID = 'HOTELS_SET_REGION_ID';
export const SET_CHILDRENS = 'HOTELS_SET_CHILDRENS';

export const HOTEL_INFO_REQUEST = 'HOTEL_INFO_REQUEST';
export const HOTEL_INFO_RESPONSE = 'HOTEL_INFO_RESPONSE';
export const HOTEL_INFO_ERROR = 'HOTEL_INFO_ERROR';

export const PAGE_NUMBER = 'HOTELS_PAGE_NUMBER';

export const getSessionIdAction = (params: SessionParams, lang: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SESSION_REQUEST,
        params
    });

    try {
        const url = `${HOTELS_HOST}/v3/search/new?checkin=${params.checkin.format('YYYY-MM-DD')}` +
            `&user_id=${params.userID}&checkout=${params.checkout.format('YYYY-MM-DD')}&guests=${JSON.stringify(params.guests)}&currency=${params.currency}&language=${lang}&region_id=${params.regionID}${params.residency && params.residency.length > 0 ? '&residency=' + params.residency : ''}`;

        const response = await fetcher(url)
            .auth(`Basic ${HOTELS_KEY}`)
            .json();

        dispatch({
            type: SESSION_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: SESSION_ERROR,
            error
        });
    }
};

export const getSearchStatusAction = (sessionID: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SEARCH_STATUS_REQUEST
    });

    try {
        const url = `${HOTELS_HOST}/v3/search/status?search_id=${sessionID}`;

        const response = await fetcher(url)
            .auth(`Basic ${HOTELS_KEY}`)
            .json();

        dispatch({
            type: SEARCH_STATUS_RESPONSE,
            response
        });
        return (response as any).result;
    } catch (error) {
        dispatch({
            type: SEARCH_STATUS_ERROR,
            error
        });
    }
};

export const getStatusPagesAction = (
    sessionID: string,
    pageID: number,
    currency: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: PAGES_STATUS_REQUEST
    });

    try {
        const url = `${HOTELS_HOST}/v2/stream/hotels/${sessionID}/status/${pageID}?currency=${currency}`;

        const response = await fetcher(url)
            .auth(`Basic ${HOTELS_KEY}`)
            .json();

        dispatch({
            type: PAGES_STATUS_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: PAGES_STATUS_ERROR,
            error
        });
    }
};

export const setPageNumber = (page: number) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: PAGE_NUMBER,
        page
    });
};

export const getPageAction = (
    sessionID: string,
    page: number
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: PAGE_REQUEST,
        page
    });

    try {
        const url = `${HOTELS_HOST}/v3/search?search_id=${sessionID}&page=${page}`;

        const response = await fetcher(url)
            .auth(`Basic ${HOTELS_KEY}`)
            .json();

        dispatch({
            type: PAGE_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: PAGE_ERROR,
            error
        });
    }
};

export const getHotelInfoAction = (
    hotelId: string,
    lang: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: HOTEL_INFO_REQUEST,
        hotelId
    });

    try {
        const url = `${HOTELS_HOST}/v3/hotel/${hotelId}?language=${lang}`;

        const response = await fetcher(url)
            .auth(`Basic ${HOTELS_KEY}`)
            .json();

        dispatch({
            type: HOTEL_INFO_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: HOTEL_INFO_ERROR,
            error
        });
    }
};

export const getRoomsAction = (params: RoomsParams, lang: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: ROOMS_REQUEST
    });

    try {
        const url = `${HOTELS_HOST}/v3/search/${params.hotelID}?checkin=${params.checkin}` +
            `&user_id=${params.userID}&checkout=${params.checkout}&guests=${JSON.stringify(params.guests)}` +
            `&currency=${params.currency}${params.residency && params.residency.length > 0 ? '&residency=' + params.residency : ''}&language=${lang}`;

        const response = await fetcher(url)
            .auth(`Basic ${HOTELS_KEY}`)
            .json();

        dispatch({
            type: ROOMS_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: ROOMS_ERROR,
            error
        });
    }
};

export const resetHotelsAction = () => (dispatch: Dispatch<any>) => dispatch({
    type: RESET_HOTELS
});

export const setCheckinAction = (checkin: Moment) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_CHECKIN,
    checkin
});

export const setCheckoutAction = (checkout: Moment) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_CHECKOUT,
    checkout
});

export const setAdultsAction = (adults: number) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_ADULTS,
    adults
});

export const setChildrenAction = (children: number) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_CHILDREN,
    children
});

export const setHotelIDAction = (hotelID: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_HOTEL_ID,
    hotelID
});

export const setRegionIDAction = (regionID: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_REGION_ID,
    regionID
});

export const setChildrensAction = (childrens: number[]) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_CHILDRENS,
    childrens,
});



// WEBPACK FOOTER //
// ./src/actions/Hotels/hotels.ts